import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchRoomTypes,
  addRoomType,
  updateRoomType,
  removeRoomType,
  fetchRoomTypeById,
  fetchRoomTypesTable,
} from "../../api/roomTypeApi";

// Thunk for getting room types

export const getRoomTypes = createAsyncThunk(
  "roomType/getRoomTypes",
        //  @ts-ignore 

  async () => {
    // dispatch(resetStatus());
    try {
      console.log("roomType123");
      
      return await fetchRoomTypes();
    } catch (error: any) {
      console.log(error,'ere');
      // return rejectWithValue(error.message);
      
    }
  }
);
export const getRoomTypesTable = createAsyncThunk(
  "roomType/getRoomTypesTable",
        //  @ts-ignore 

  async ({page,limit}, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await fetchRoomTypesTable(page,limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



export const getRoomTypeById = createAsyncThunk(
    "roomType/getRoomTypeById",
    async (id: string, {dispatch, rejectWithValue }) => {
      dispatch(resetStatus());
      try {
        return await fetchRoomTypeById(id);
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

// Thunk for creating a new room type
export const createRoomType = createAsyncThunk(
  "roomType/createRoomType",
  async (newRoomType: any, { dispatch,rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await addRoomType(newRoomType);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for editing a room type
export const editRoomType = createAsyncThunk(
  "roomType/editRoomType",
  async (
    { id, updatedRoomType }: { id: string; updatedRoomType: any },
    {dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());
    try {
      return await updateRoomType(id, updatedRoomType);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for deleting a room type
export const deleteRoomType = createAsyncThunk(
  "roomType/deleteRoomType",
  async (id: string, {dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await removeRoomType(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Room Type Slice
const roomTypeSlice = createSlice({
  name: "roomType",
  initialState: {
    roomTypes: [] as any[],
    roomTypesTable: [] as any[],

    roomType: null as any | null, 
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getRoomTypes

      .addCase(getRoomTypes.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.roomTypes = action.payload;
      })
      .addCase(getRoomTypes.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(getRoomTypesTable.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.roomTypesTable = action.payload;
      })
      .addCase(getRoomTypesTable.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Handle createRoomType
      .addCase(createRoomType.fulfilled, (state, action: PayloadAction<any>) => {
        if(Array.isArray(state.roomTypes)){
          state.roomTypes.push(action.payload);
          state.status = true;
          state.msg = "Room type created successfully.";
        }else{
console.log('room type not aaray');

        }
      
      })
      .addCase(getRoomTypeById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        console.log(action.payload,'action.payload');
        
        state.roomType = action.payload;
      })

      // Handle editRoomType
      .addCase(editRoomType.fulfilled, (state, action: PayloadAction<any>) => {
        // Log roomTypes to ensure it's an array
        console.log("state.roomTypes:", state.roomTypes);
        
        if (Array.isArray(state.roomTypes)) {
          const { id, data } = action.payload;
          const index = state.roomTypes.findIndex((roomType) => roomType.id === id);
          if (index !== -1) {
            state.roomTypes[index] = data;
          }
          state.status = true;
          state.msg = "Room type updated successfully.";
        } else {
          console.error("Error: state.roomTypes is not an array!");
        }
      })

      // Handle deleteRoomType
      .addCase(deleteRoomType.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.roomTypes)) {
          state.roomTypes = state.roomTypes.filter((roomType) => roomType._id !== action.payload);
        } else {
          console.error("roomTypes is not an array", state.roomTypes);
        }
        state.status = true;
        state.msg = "Room type deleted successfully.";
      });
  },
});

export const { resetStatus } = roomTypeSlice.actions;
export default roomTypeSlice.reducer;
